import { render, staticRenderFns } from "./AdvancesList.vue?vue&type=template&id=80691b0e&"
import script from "./AdvancesList.vue?vue&type=script&lang=js&"
export * from "./AdvancesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports